import { getPlayerTags } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { PlayerTagsUpdatePopover } from "./PlayerTagsUpdatePopover";
import { TagsRenderer } from "@/components/tags/TagsRenderer";
import { LoadingSmall } from "@/components/LoadingSmall";

interface Props {
  playerGuid: string;
  playerIntId: number;
}

export const PlayerTags: React.FC<Props> = ({ playerGuid, playerIntId }) => {
  const activeFirm = useSelector(selectActiveFirm);

  const queryKey = ["playerTags", String(activeFirm?.firmGuid), playerGuid];
  const queryClient = useQueryClient();
  const { data, isFetching } = useQuery({
    queryKey,
    queryFn: () => getPlayerTags(String(activeFirm?.firmGuid), playerGuid),
  });

  if (isFetching) {
    return <LoadingSmall />;
  }

  const tags = data?.data?.result || [];

  return (
    <div className="flex flex-wrap gap-2">
      <TagsRenderer tagNames={tags.map((tag) => tag.tagName)} />
      <PlayerTagsUpdatePopover
        playerIntId={playerIntId}
        playerTags={tags}
        onUpdate={() => {
          queryClient.invalidateQueries({ queryKey });
        }}
      />
    </div>
  );
};
